import { createAction } from '@reduxjs/toolkit'

import type {
  TAddCompanyToCompanyGroupResponse,
  TCreateCompanyGroupResponse,
  TGetCompanyGroupsResponse,
  TGetCompanyStructureSyncStatusResponse,
  TRemoveCompanyFromCompanyGroupResponse,
  TUpdateCompanyGroupResponse
} from '@homepal/api-contract'

// tryGetAllCompanyGroups
export const getAll = createAction('get_all_company_groups')
export const getAllSuccess = createAction<TGetCompanyGroupsResponse>(
  'get_all_company_groups_success'
)
export const getAllFailed = createAction('get_all_company_groups_failed')

// tryCreateCompanyGroup
export const create = createAction('create_company_group')
export const createSuccess = createAction<TCreateCompanyGroupResponse>(
  'create_company_group_success'
)
export const createFailed = createAction('create_company_group_failed')

// tryUpdateCompanyGroup
export const update = createAction('update_company_group')
export const updateSuccess = createAction<TUpdateCompanyGroupResponse>(
  'update_company_group_success'
)
export const updateFailed = createAction('update_company_group_failed')

// tryDeleteCompanyGroup
export const destroy = createAction('destroy_company_group')
export const destroySuccess = createAction<{ id: string }>(
  'destroy_company_group_success'
)
export const destroyFailed = createAction('destroy_company_group_failed')

// tryAddCompanyToCompanyGroup
export const addCompany = createAction('add_company_to_company_group')
export const addCompanySuccess =
  createAction<TAddCompanyToCompanyGroupResponse>(
    'add_company_to_company_group_success'
  )
export const addCompanyFailed = createAction(
  'add_company_to_company_group_failed'
)

// tryGetCompanyStructureSyncStatus
export const getSyncStatus = createAction('get_company_structure_sync_status')
export const getSyncStatusSuccess =
  createAction<TGetCompanyStructureSyncStatusResponse>(
    'get_company_structure_sync_status_success'
  )
export const getSyncStatusFailed = createAction(
  'get_company_structure_sync_status_failed'
)

// tryRerunOntology — the run itself goes through the v3 data-products
// start-job-run endpoint; these actions only track the local state.
export const rerunOntology = createAction('rerun_company_structure_ontology')
export const rerunOntologySuccess = createAction(
  'rerun_company_structure_ontology_success'
)
export const rerunOntologyFailed = createAction(
  'rerun_company_structure_ontology_failed'
)

// tryRemoveCompanyFromCompanyGroup
export const removeCompany = createAction('remove_company_from_company_group')
export const removeCompanySuccess =
  createAction<TRemoveCompanyFromCompanyGroupResponse>(
    'remove_company_from_company_group_success'
  )
export const removeCompanyFailed = createAction(
  'remove_company_from_company_group_failed'
)
